module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=FI - Finland.6a7fff81.svg";